import { Flex } from "@qws-org/ui-kit";
import type { FC } from "react";
import { useRef, useState } from "react";
import { Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import type { Action, MainBannerV3Data, Pages } from "~/core";
import { BannerImage } from "~/features/main-bannerV3/components/BannerImage";
import { PaginationDashes } from "~/features/main-bannerV3/components/PaginationDashes";

type MainBannerV3Props = {
  data: MainBannerV3Data;
  isControlInactive: (control: Action) => boolean;
  getUrl: (page: Pages) => string;
  onCallAction: (action: Action) => void;
};

export const MainBannerV3: FC<MainBannerV3Props> = ({
  data,
  isControlInactive,
  getUrl,
  onCallAction,
}) => {
  const banners = data?.banners?.map((item) => item?.main_banner_v3_banners_id);
  if (!banners?.length) {
    return null;
  }

  const isDraggingRef = useRef(false);

  const handleTouchMove = (): void => {
    isDraggingRef.current = true;
  };

  const handleTouchEnd = (): void => {
    setTimeout(() => {
      isDraggingRef.current = false;
    }, 100);
  };

  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <Flex
      align="center"
      justify="center"
      flexDirection={"column"}
      p={{ px: 16, py: 16 }}
      md={{
        p: { px: 24, py: 24 },
      }}
      d={{
        p: { px: 32, py: 32 },
      }}
      gap={16}
    >
      <Swiper
        slidesPerView="auto"
        centeredSlides={banners.length === 1}
        spaceBetween={8}
        modules={[Navigation, Pagination]}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
        grabCursor
        loop={data?.loop ?? false}
        onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
      >
        {banners.map((banner, i) => {
          return (
            <SwiperSlide key={i}>
              <BannerImage
                banner={banner}
                isControlInactive={isControlInactive}
                getUrl={getUrl}
                onCallAction={onCallAction}
                isDraggingRef={isDraggingRef}
              />
            </SwiperSlide>
          );
        })}
      </Swiper>
      <PaginationDashes
        slidesNumber={banners?.length ?? 0}
        activeIndex={activeIndex}
      />
    </Flex>
  );
};
